<template>
  <div class="baseStationPowerRecord-container">
    <el-form
      size="medium"
      :inline="true"
      :model="queryForm"
      ref="queryForm"
      class="input-form-inline"
      @submit.native.prevent
    >
      <div>
        <el-form-item class="query-form r-20" prop="time">
          <date-picker
            :startTime="queryForm.startTime"
            :endTime="queryForm.endTime"
            @changeStart="changeStart"
            @changeEnd="changeEnd"
          >
          </date-picker>
        </el-form-item>
        <el-form-item class="r-20" prop="name">
          <el-input
            v-model.trim="queryForm.name"
            @keyup.enter.native="query"
            placeholder="站址名称"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="code">
          <el-input
            v-model.trim="queryForm.code"
            @keyup.enter.native="query"
            placeholder="站址编码"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="dcLoadCurrent">
          <el-input
            v-model.trim="queryForm.dcLoadCurrent"
            @keyup.enter.native="query"
            placeholder="请输入直流负载值"
          ></el-input>
        </el-form-item>
        <el-form-item prop="areaIds">
          <el-cascader
            v-model="queryForm.areaIds"
            :options="areaList"
            :props="optionProps"
            placeholder="请选择区域"
            collapse-tags
            clearable
          ></el-cascader>
        </el-form-item>
        <el-button type="primary" @click="query">查询</el-button>
        <el-button @click="reset">取消</el-button>
      </div>
      <div style="margin-bottom:20px">
        <el-button type="primary" @click.stop="exportButton">导出</el-button>
      </div>
    </el-form>
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      size="mini"
      stripe
      height="560px"
      v-loading="loading"
    >
      <el-table-column
        width="20"
        align="center"
        style="padding: 0"
      ></el-table-column>
      <el-table-column type="index" label="序号" width="55"></el-table-column>
      <el-table-column
        prop="stationName"
        label="站址名称"
        min-width="140"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="stationCode"
        label="站址编码"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="company"
        label="所属公司"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="province"
        label="所属省"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="city"
        label="所属市"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="area"
        label="所属区县"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="dynamoCount"
        label="发电工单数"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot="header">
          <span>发电工单数</span>
          <span @click="powerCount" class="iconfont icon-sort"></span>
        </template>
      </el-table-column>
      <el-table-column
        prop="exceedDynamoCount"
        label="超过24小时发电工单数"
        min-width="170"
        show-overflow-tooltip
      >
        <template slot="header">
          <span>超过24小时发电工单数</span>
          <span @click="powerCountOver" class="iconfont icon-sort"></span>
        </template>
      </el-table-column>
      <el-table-column
        prop="dynamoSuccessCount"
        label="完成发电工单数"
        min-width="120"
        show-overflow-tooltip
      >
        <template slot="header">
          <span>完成发电工单数</span>
          <span @click="powerSuccessCount" class="iconfont icon-sort"></span>
        </template>
      </el-table-column>
      <el-table-column
        prop="dynamoTime"
        label="总发电时长（小时）"
        min-width="160"
        show-overflow-tooltip
      >
        <template slot="header">
          <span>总发电时长（小时）</span>
          <span @click="powerTotalTime" class="iconfont icon-sort"></span>
        </template>
      </el-table-column>
      <el-table-column
        prop="dynamoEnergy"
        label="总发电量（KW·h）"
        min-width="160"
        show-overflow-tooltip
      >
        <template slot="header">
          <span>总发电量（KW·h）</span>
          <span @click="powerTotalCount" class="iconfont icon-sort"></span>
        </template>
      </el-table-column>
      <el-table-column
        prop="dynamoOil"
        label="总发电油耗（L）"
        min-width="160"
        show-overflow-tooltip
      >
        <template slot="header">
          <span>总发电油耗（L）</span>
          <span @click="powerTotalOil" class="iconfont icon-sort"></span>
        </template>
      </el-table-column>
      <el-table-column
        prop="lastDynamoDate"
        label="最近一次发电"
        min-width="160"
        show-overflow-tooltip
      >
        <template slot="header">
          <span>最近一次发电</span>
          <span @click="lastPower" class="iconfont icon-sort"></span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        fixed="right"
        min-width="80"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <el-button type="text" @click="powerRecordDetail(row)"
            >工单记录</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="limit"
      layout="total, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
  </div>
</template>

<script>
import DatePicker from "@/components/DatePicker.vue";
export default {
  name: "BaseStationPowerRecord",
  components: {
    DatePicker,
  },
  data() {
    return {
      queryForm: {
        areaIds: [],
        name: "",
        code: "",
        dcLoadCurrent: "",
        startTime: "",
        endTime: "",
      },
      loading: false,
      areaList: [],
      optionProps: {
        value: "id",
        multiple: true,
        emitPath: true,
      },
      tableData: [],
      operationsList: [
        { value: "2", label: "解绑车辆" },
        { value: "1", label: "绑定车辆" },
      ],
      dynamoCountSort: 0,
      exceedDynamoCountSort: 0,
      dynamoSuccessCountSort: 0,
      dynamoTimeSort: 0,
      dynamoEnergySort: 0,
      dynamoOilSort: 0,
      lastDynamoDateSort: 0,
      total: 0,
      limit: 10,
      currentPage: 1,
    };
  },
  created() {
    let currentPage = this.$route.params.currentPage;
    if (currentPage) {
      this.currentPage = parseInt(currentPage);
    }
    this.getAreaList();
    this.getRecordList();
  },
  methods: {
    changeStart(val) {
      this.queryForm.startTime = val;
    },
    changeEnd(val) {
      this.queryForm.endTime = val;
    },
    powerRecordDetail(row) {
      this.$router.push({
        name: "PowerRecordMore",
        params: {
          data: row,
        },
      });
      // 存储数据
      if (sessionStorage.getItem("userInfo") != "") {
        sessionStorage.removeItem("userInfo");
      }
      sessionStorage.setItem("baseCurrentPage", this.currentPage);
      sessionStorage.setItem("userInfo", JSON.stringify(row));
    },
    powerCount() {
      this.dynamoCountSort = this.dynamoCountSort == 1 ? 2 : 1;
      this.exceedDynamoCountSort = 0;
      this.dynamoSuccessCountSort = 0;
      this.dynamoTimeSort = 0;
      this.dynamoEnergySort = 0;
      this.dynamoOilSort = 0;
      this.lastDynamoDateSort = 0;
      this.getRecordList();
    },
    powerCountOver() {
      this.dynamoCountSort = 0;
      this.exceedDynamoCountSort = this.exceedDynamoCountSort == 1 ? 2 : 1;
      this.dynamoSuccessCountSort = 0;
      this.dynamoTimeSort = 0;
      this.dynamoEnergySort = 0;
      this.dynamoOilSort = 0;
      this.lastDynamoDateSort = 0;
      this.getRecordList();
    },
    powerSuccessCount() {
      this.dynamoCountSort = 0;
      this.exceedDynamoCountSort = 0;
      this.dynamoSuccessCountSort = this.dynamoSuccessCountSort == 1 ? 2 : 1;
      this.dynamoTimeSort = 0;
      this.dynamoEnergySort = 0;
      this.dynamoOilSort = 0;
      this.lastDynamoDateSort = 0;
      this.getRecordList();
    },
    powerTotalTime() {
      this.dynamoCountSort = 0;
      this.exceedDynamoCountSort = 0;
      this.dynamoSuccessCountSort = 0;
      this.dynamoTimeSort = this.dynamoTimeSort == 1 ? 2 : 1;
      this.dynamoEnergySort = 0;
      this.dynamoOilSort = 0;
      this.lastDynamoDateSort = 0;
      this.getRecordList();
    },
    powerTotalCount() {
      this.dynamoCountSort = 0;
      this.exceedDynamoCountSort = 0;
      this.dynamoSuccessCountSort = 0;
      this.dynamoTimeSort = 0;
      this.dynamoEnergySort = this.dynamoEnergySort == 1 ? 2 : 1;
      this.dynamoOilSort = 0;
      this.lastDynamoDateSort = 0;
      this.getRecordList();
    },
    powerTotalOil() {
      this.dynamoCountSort = 0;
      this.exceedDynamoCountSort = 0;
      this.dynamoSuccessCountSort = 0;
      this.dynamoTimeSort = 0;
      this.dynamoEnergySort = 0;
      this.dynamoOilSort = this.dynamoOilSort == 1 ? 2 : 1;
      this.lastDynamoDateSort = 0;
      this.getRecordList();
    },
    lastPower() {
      this.dynamoCountSort = 0;
      this.exceedDynamoCountSort = 0;
      this.dynamoSuccessCountSort = 0;
      this.dynamoTimeSort = 0;
      this.dynamoEnergySort = 0;
      this.dynamoOilSort = 0;
      this.lastDynamoDateSort = this.lastDynamoDateSort == 1 ? 2 : 1;
      this.getRecordList();
    },
    query() {
      this.getRecordList();
    },
    reset() {
      this.$resetForm(this, "queryForm");
      this.queryForm.startTime = "";
      this.queryForm.endTime = "";
      this.getRecordList();
    },
    exportButton() {
      let _this = this;
      let url = "";
      url =
        "/api/base/station/Statistics/list/export?areaIds=" +
        _this.queryForm.areaIds.join(",") +
        "&name=" +
        _this.queryForm.name +
        "&code=" +
        _this.queryForm.code;
      window.location.href = url;
    },
    async getAreaList() {
      let { data: res } = await this.$axios.get("/api/sys/area/list");
      if (res.code == 1) {
        // 处理最后一级children为空时不显示无数据空白节点页面
        let data = this.handleTreeData(res.data);
        this.areaList = data;
      } else {
        this.$message.warning(res.msg);
      }
    },
    // el-cascader 控件 最后一级出现空白 暂无数据 页面
    handleTreeData(data) {
      data.forEach((item) => {
        if (item.children.length == 0) {
          item.children = undefined;
        } else {
          this.handleTreeData(item.children);
        }
      });
      return data;
    },
    async getRecordList() {
      let _this = this;
      let params = new FormData();
      _this.loading = true;
      params.append("areaIds", _this.queryForm.areaIds.join(","));
      params.append("name", _this.queryForm.name);
      params.append("code", _this.queryForm.code);
      if (!_this.queryForm.startTime) {
        params.append("startTime", "");
      } else {
        params.append("startTime", _this.queryForm.startTime);
      }
      if (!_this.queryForm.endTime) {
        params.append("endTime", "");
      } else {
        params.append("endTime", _this.queryForm.endTime);
      }
      if (!_this.queryForm.dcLoadCurrent) {
        params.append("dcLoadCurrent", 0);
      } else {
        params.append("dcLoadCurrent", _this.queryForm.dcLoadCurrent);
      }
      params.append("dynamoCountSort", _this.dynamoCountSort);
      params.append("exceedDynamoCountSort", _this.exceedDynamoCountSort);
      params.append("dynamoSuccessCountSort", _this.dynamoSuccessCountSort);
      params.append("dynamoTimeSort", _this.dynamoTimeSort);
      params.append("dynamoEnergySort", _this.dynamoEnergySort);
      params.append("dynamoOilSort", _this.dynamoOilSort);
      params.append("lastDynamoDateSort", _this.lastDynamoDateSort);
      params.append("limit", _this.limit);
      params.append("page", _this.currentPage);
      let { data: res } = await _this.$axios.post(
        "/api/base/station/Statistics/dynamo/list",
        params
      );
      if (res.code == 1) {
        _this.tableData = res.data.list;
        _this.total = res.data.totalCount;
      }
      _this.loading = false;
    },
    // async getDeptList() {
    //   let _this = this;
    //   let { data: res } = await _this.$axios.get("/api/sys/dept/list");
    //   if (res.code == 1) {
    //     _this.deptTreeData = res.data;
    //   } else {
    //     _this.$message.warning(res.msg);
    //   }
    // },
    //pagesize改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    //页数改变时触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getRecordList();
    },
  },
};
</script>

<style lang="scss" scoped>
.baseStationPowerRecord-container {
  height: calc(100% - 60px);
  margin: 20px;
  padding: 20px;
  padding-top: 0;
  background: #fff;
  /deep/ .el-cascader {
    width: 100%;
    .el-cascader__tags .el-tag {
      max-width: 62%;
    }
    .el-input__inner {
      height: 32px !important;
      line-height: 32px;
    }
  }
  .query-form {
    /deep/ .el-form-item__content {
      width: auto;
      .el-date-editor {
        width: auto;
        .el-input__inner {
          width: 260px;
        }
      }
      .time {
        display: flex;
        justify-content: space-evenly;
        > :nth-child(1) {
          width: 260px;
        }
        > :nth-child(2) {
          margin-left: 0 !important;
          width: 20px;
          text-align: center;
        }
        > :nth-child(3) {
          width: 260px;
        }
      }
    }
  }
}
</style>
